'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadUserOutfeats = exports.getUserOutfeats = exports.userOutfeatFound = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends5 = require('babel-runtime/helpers/extends');

var _extends6 = _interopRequireDefault(_extends5);

exports.default = user;

var _ApiClient = require('../../helpers/ApiClient');

var _actionTypes = require('../actionTypes');

var _entities = require('./entities');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var USER_ENDPOINT = '/user/';
var OUTFEATS_ENDPOINT = '/outfeats';

var initialState = {};

function user() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  switch (action.type) {
    case _actionTypes.userActions.LOAD_USER_OUTFEATS.STARTED:
      return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.username, {
        isLoading: true
      }));
    case _actionTypes.userActions.LOAD_USER_OUTFEATS.COMPLETED:
      return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.username, {
        isLoading: false,
        user: action.result.user,
        outfeats: action.result.outfeats
      }));
    case _actionTypes.userActions.LOAD_USER_OUTFEATS.FAILED:
      return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.username, {
        error: action.error,
        isLoading: false
      }));
    default:
      return state;
  }
}

var userOutfeatFound = exports.userOutfeatFound = function userOutfeatFound(data) {
  return {
    type: _actionTypes.userActions.LOAD_USER_OUTFEATS.COMPLETED,
    result: data
  };
};

var getUserOutfeats = exports.getUserOutfeats = function getUserOutfeats(username) {
  return fetch((0, _ApiClient.formatUrl)(USER_ENDPOINT + username + OUTFEATS_ENDPOINT)).then(function (response) {
    return response.json();
  });
};

var loadUserOutfeats = exports.loadUserOutfeats = function loadUserOutfeats(username) {
  return {
    types: _actionTypes.userActions.LOAD_USER_OUTFEATS.TYPES,
    username: username,
    promise: function promise(client) {
      return client.get(USER_ENDPOINT + username + OUTFEATS_ENDPOINT).then(function (result) {
        var outfeats = (0, _entities.normalizer)('outfeats', result.outfeats);
        return (0, _extends6.default)({}, result, outfeats);
      });
    }
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/user.js
 ** module id = 462
 ** module chunks = 0
 **/